
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/[id]",
      function () {
        return require("private-next-pages/community/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/[id]"])
      });
    }
  